// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","input":"ConfirmationDialog__input--X7","confirmationText":"ConfirmationDialog__confirmationText--B8"};